import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export const IconStop = ({
    width = '16',
    height = '16',
    className = '',
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                d="M 3 1 L 13 1 C 14.104 1 15 1.896 15 3 L 15 13 C 15 14.104 14.104 15 13 15 L 3 15 C 1.896 15 1 14.104 1 13 L 1 3 C 1 1.896 1.896 1 3 1 Z"
                fill="#333333"
            />
        </svg>
    );
};

export default IconStop;
